import Cookie from "./Cookie";
import Variable from "./Variable";

export default class Language {
    static getLanguage() {
        switch (this.getFromCookie()) {
            case 'pt-BR': return 'pt-BR';
            case 'en-US': return 'en-US';
            case 'pt': return 'pt-BR';
            case 'en': return 'en-US';
            default: return 'pt-BR';
        }
    }

    static getLanguageForApiParameter() {
        switch (this.getFromCookie()) {
            case 'pt-BR': return 'pt';
            case 'en-US': return 'en';
            case 'pt': return 'pt';
            case 'en': return 'en';
            default: return 'pt';
        }
    }

    static getFromCookie() {
        let language = document.querySelector('html').getAttribute('lang');

        if (Variable.notEmpty(language)) {
            return language;
        }

        return Cookie.get('pll_language', 'pt');
    }

    static isPortuguese() {
        return this.getLanguage() === 'pt-BR';
    }
}
